/* Movatic WMS — Scanner por Câmera (usa BarcodeDetector quando disponível) */
import React, { useEffect, useRef, useState } from "react"

type Props = {
    onRead: (code: string) => void
    className?: string
}

export default function CameraScanner({ onRead, className }: Props) {
    const videoRef = useRef<HTMLVideoElement>(null)
    const [err, setErr] = useState<string>("")
    const [ready, setReady] = useState(false)

    useEffect(() => {
        let stream: MediaStream | null = null
        let raf = 0
        let detector: any = null

        async function start() {
            try {
                // Pede câmera traseira quando possível
                stream = await navigator.mediaDevices.getUserMedia({
                    video: { facingMode: { ideal: "environment" } },
                    audio: false,
                })
                if (!videoRef.current) return
                videoRef.current.srcObject = stream
                await videoRef.current.play()
                setReady(true)

                // Usa API nativa se existir
                // @ts-ignore
                const BD = (window as any).BarcodeDetector
                if (BD) {
                    detector = new BD({ formats: ["ean_13", "ean_8", "code_128", "qr_code"] })
                } else {
                    setErr("BarcodeDetector não suportado neste navegador. Use leitor físico ou digite.")
                    return
                }

                const loop = async () => {
                    raf = requestAnimationFrame(loop)
                    if (!videoRef.current || !detector) return
                    try {
                        const codes = await detector.detect(videoRef.current)
                        if (codes && codes.length) {
                            const value = codes[0]?.rawValue?.trim()
                            if (value) {
                                stop()
                                onRead(value)
                            }
                        }
                    } catch {
                        // ignore
                    }
                }
                raf = requestAnimationFrame(loop)
            } catch (e: any) {
                setErr(e?.message ?? "Não foi possível acessar a câmera.")
            }
        }

        function stop() {
            if (raf) cancelAnimationFrame(raf)
            if (stream) {
                stream.getTracks().forEach((t) => t.stop())
                stream = null
            }
        }

        start()
        return () => stop()
    }, [onRead])

    return (
        <div className={className}>
            <div className="aspect-video bg-black/80 relative">
                <video ref={videoRef} className="h-full w-full object-cover" />
                {!ready && (
                    <div className="absolute inset-0 grid place-items-center text-xs text-white/80">
                        Abrindo câmera…
                    </div>
                )}
            </div>
            {err && (
                <div className="p-2 text-xs text-red-600 dark:text-red-400">{err}</div>
            )}
        </div>
    )
}
